<div class="pages">
    <app-header *ngIf="isLogin"></app-header>
    <app-sidemenu></app-sidemenu>
    <router-outlet></router-outlet>
</div>